// extracted by mini-css-extract-plugin
export var actions = "_c8-g";
export var benefitCard = "_c8-b";
export var benefitIcon = "_c8-d";
export var benefitLabel = "_c8-f";
export var benefits = "_c8-a";
export var benefitsSection = "_c8-8";
export var bodyText = "_c8-7";
export var closeButton = "_c8-2";
export var content = "_c8-3";
export var eyebrow = "_c8-4";
export var heading = "_c8-5";
export var image = "_c8-i";
export var imagePanel = "_c8-h";
export var modal = "_c8-0";
export var offerCard = "_c8-c";
export var offerIcon = "_c8-e";
export var sectionLabel = "_c8-9";
export var shell = "_c8-1";
export var title = "_c8-6";